import { Routes } from "@angular/router";
import { environment } from "src/environments/environment";
import { RestrictPageComponent } from "./common/restrict-page/restrict-page.component";
import { AccountManagementResolver } from "./services/account-management.resolver";
import { AccountManagementLoginGuard } from "./services/account-mgmt-login.resolver";
import { SignOffComponent } from "./shared/components/sign-off/sign-off.component";
import { RootComponent } from "./root-component/root.component";

const guard = environment.ENABLE_OKTA
  ? AccountManagementResolver
  : AccountManagementLoginGuard;

export const GlobalNavRouting: Routes = [
  {
    path: "logout",
    component: SignOffComponent,
  },
  {
    path: 'lines',
    canActivate: [guard],
    loadChildren: () =>
      import("./manage-lines/manage-lines.module").then((m) => m.ManageLinesModule)
  },
  {
    path: 'licenses',
    canActivate: [guard],
    loadChildren: () =>
      import("./manage-lines/manage-lines.module").then((m) => m.ManageLinesModule)
  },
  {
    path: 'line-details',
    canActivate: [guard],
    loadChildren: () =>
      import("./line-details/line-details.module").then((m) => m.LineDetailsModule)
  },
  {
    path: "",
    component: RootComponent,
    pathMatch: "full",
  },
  {
    path: 'lines/changeservice',
    canActivate: [guard],
    loadChildren: () =>
      import("./change-service/change-service.module").then((m) => m.ChangeServiceModule)
  },
  {
    path: 'view-line-history-transaction',
    canActivate: [guard],
    loadChildren: () =>
      import("./view-line-history/view-line-history.module").then((m) => m.ViewLineHistoryModule)
  },
  {
    path: 'home',
    canActivate: [guard],
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomeModule)
  },
  {
    path: 'approval-dashboard',
    canActivate: [guard],
    loadChildren: () =>
      import("./approval-dashboard/approval-dashboard.module").then((m) => m.ApprovalDashboardModule)
  },
  {
    path: 'affiliations',
    canActivate: [guard],
    loadChildren: () => import("./affiliations/affiliations.module").then((m) => m.AffiliationsModule)
  },
  {
    path: 'change-rateplan',
    canActivate: [guard],
    loadChildren: () =>
      import("./change-rate-plan/change-rate-plan.module").then((m) => m.ChangeRatePlanModule)
  },
  {
    path: 'restrict-page',
    component: RestrictPageComponent,
  },
  {
    path: 'transactions',
    canActivate: [guard],
    loadChildren: () =>
      import("./transactions/transactions.module").then((m) => m.TransactionsModule)
  }
];
